import React from "react";

import { Props } from "./types";
import { ScrollBar } from "./scrollBar";
import { ScrollZone } from "./scrollZone";
import { Context } from "./context";

function ScrollRoot({ children }: Props) {
  const gutters = React.useRef<
    { id: string; ref: React.MutableRefObject<HTMLDivElement | null> }[]
  >([]);
  const subscribers = React.useRef<
    { id: string; ref: React.MutableRefObject<HTMLDivElement | null> }[]
  >([]);

  return (
    <Context.Provider
      value={{
        gutters: gutters.current,
        subscribers: subscribers.current,
        registerGutter: (gutter) => {
          gutters.current = [...gutters.current, gutter];
        },
        removeGutter: (id) => {
          gutters.current = gutters.current.filter(
            (gutter) => gutter.id !== id,
          );
        },
        registerSubscriber: (obs) => {
          subscribers.current = [...subscribers.current, obs];
        },
        removeSubscriber: ({ id }) => {
          subscribers.current = subscribers.current.filter(
            (obs) => obs.id !== id,
          );
        },
      }}
    >
      {children}
    </Context.Provider>
  );
}

export { ScrollRoot, ScrollBar, ScrollZone };
